module.exports = __webpack_public_path__ + "img/plane-fill-darkblue.757c1c10.svg";